import { render, staticRenderFns } from "./CompletedReview.vue?vue&type=template&id=dc35b8de&scoped=true"
import script from "./CompletedReview.vue?vue&type=script&lang=js"
export * from "./CompletedReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc35b8de",
  null
  
)

export default component.exports